<template>
    <!-- Left side column. contains the logo and sidebar -->
    <aside class="left-aside sidebar-offcanvas" :class="{'left-aside-small': !showBigMenu}">
        <!-- sidebar: style can be found in sidebar-->
        <section class="sidebar">
            <div class="float-right" v-if="showBigMenu">
                <a class="sidebar-toggle" @click.prevent="toggle_menu">
                    <i class="fa fa-arrow-left"></i>
                </a>
            </div>
            <div id="menu" role="navigation">
                <div class="nav_profile" v-if="showBigMenu">
                    <profile></profile>
                </div>
                <vmenu>
                    <a class="listbrdr pointer" v-if="!showBigMenu" @click="toggle_menu">
                        <div class="menu-item">
                            <i class="leftmenu_icon fa fa-arrow-right"></i>
                        </div>
                    </a>
                    <template v-for="item in menuitems">
                        <li class="divider mt-3 " v-if="item.title">
                            <span v-if="showBigMenu">{{ uLang(item.name) }}</span>
                        </li>
                        <vsub-menu v-if="item.child" :title="item.name" :icon="item.icon">
                            <vmenu-item v-for="child in item.child" :link="child.link" :icon="child.icon"
                                        :key="child.name" :exclusion="child.exclusion"><span
                                v-if="showBigMenu">{{ uLang(child.name) }}</span>
                            </vmenu-item>
                        </vsub-menu>
                        <vmenu-item v-if="item.link" :link="item.link" :exclusion="item.exclusion" :icon="item.icon"
                                ><span v-if="showBigMenu">{{
                                uLang(item.name)
                            }}</span>
                        </vmenu-item>
                    </template>
                </vmenu>
                <!-- / .navigation -->
            </div>
            <!-- menu -->
        </section>
    </aside>
</template>
<script>
import {
    vmenu,
    vmenuItem,
    vsubMenu
} from './menu';

import profile from "../left-profile/user_profile_current.vue"
import menuItemsList from "~/menus/items.js";
import {mapGetters} from 'vuex'

export default {
    name: "left-side",
    components: {
        vmenu,
        vsubMenu,
        vmenuItem,
        profile
    },
    props: {
        showBigMenu: {
            default: true
        }
    },
    data() {
        return {
            menuitems: menuItemsList
        }
    },

    computed: {
        ...mapGetters({
            user: 'authUser',
        })
    },

    mounted() {
        this.setMenuItems();
        this.$on('CLICK', this.toggle_menu)
    },

    methods: {
        toggle_menu() {
            this.$store.commit('LEFT_MENU', "toggle");
        },
        setMenuItems() {
            let items = []

            for (let menuitem in menuItemsList) {
                let item = menuItemsList[menuitem]

                if (!item.hasOwnProperty('permission') || this.$can(item.permission)) {
                    items.push(item)
                }
            }

            this.menuitems = items
        },
    },
}
</script>
<style scoped lang="scss">
@import "../../css/customvariables";

.left-aside {
    width: $left_menu_width;
    background: $leftmenu_color;
    background-repeat: repeat-y;
    transition: width 0.1s;
}

.hidden {
    display: none
}

.left-aside-small {
    width: 75px;
    background: $leftmenu_color;
    background-repeat: repeat-y;
}

.navigation {
    padding: 0;
}

.divider {
    margin-top: 10px;
    list-style-type: none;
    border-bottom: 1px solid #ececec;
    padding-bottom: 6px;
}

.divider span {
    font-size: 15px;
    font-weight: 700;
    color: $divider-leftheader;
    margin: 20px 20px -15px 20px;
}

.sidebar {
    display: block;
    font-size: 14px;
    letter-spacing: 1px;
}

.content {
    display: block;
    width: auto;
    overflow-x: hidden;
    padding: 0 15px;
}

.badge-success {
    background-color: #22d69d;
}

.badge {
    padding: 0.60em 0.7em;
    border-radius: 0.75rem;
}

.nav_profile {
    border-bottom: 1px solid #eee;
}

.sidebar-toggle {
    float: left;
    color: $menu_color;
    font-size: 19px;
    padding-top: 10px;
    padding-right: 10px;
    padding-left: 0;
}

.leftmenu_icon {
    margin-right: 10px;
    line-height: 22px;
    height: 23px;
    width: 20px;
    text-align: center;
    font-size: 16px;
    color: $menu_color;
}

a {
    color: $menu_color;
    font-size: 19px;
    position: relative;
    display: block;
    line-height: 21px;
    padding: 10px 30px;

    &:hover {
        color: $menu_hover_color;
    }

    &.active {
        color: $menu_active_color;
        background-color: $menu_active;

        i {
            color: $active_icon;
        }
    }
}
</style>
